export default {
  namespaced: true,
  state: {
    surveys: [],
    surveysCompleted: [],
    survey: null,
  },
  actions: {
    // eslint-disable-next-line camelcase
    GetSurveysList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'surveys', value: [] });
      commit('setField', { name: 'surveysCompleted', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('survey/api/v3/surveys/surveys-list', { ...payload })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'surveys', value: response.data.surveys });
              commit('setField', { name: 'surveysCompleted', value: response.data.completed });
              resolve(response.data);
            }
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSurvey({ commit, state, dispatch }, id) {
      commit('setField', { name: 'survey', value: null });
      return new Promise((resolve, reject) => {
        const survey = state.surveys.find(s => s.id === id);
        if (survey) {
          commit('setField', { name: 'survey', value: survey });
          resolve(survey);
        } else {
          dispatch('HandleError', new Error('Опрос не найден'), { root: true });
          reject(new Error('Опрос не найден'));
        }
      });
    },
    InitialStoreNews({ commit }) {
      commit('setField', { name: 'surveys', value: [] });
      commit('setField', { name: 'surveysCompleted', value: [] });
      commit('setField', { name: 'survey', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
